// A school invite opened before signing in is remembered here, so the app can
// bring the teacher back to it after they sign up or log in.
const KEY = 'teslp-school-invite';

export const rememberInvite = (token) => {
  try { localStorage.setItem(KEY, token); } catch { /* ignore */ }
};

export const pendingInvite = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const forgetInvite = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

// A visitor who picked the Business plan on the homepage is sent to the
// Business section of the Subscription page once they've signed up
const BUSINESS_KEY = 'teslp-business-intent';

export const rememberBusinessIntent = () => {
  try { localStorage.setItem(BUSINESS_KEY, '1'); } catch { /* ignore */ }
};

export const forgetBusinessIntent = () => {
  try { localStorage.removeItem(BUSINESS_KEY); } catch { /* ignore */ }
};

// Where to go after signing up or verifying: back to a school invite if there is one
export const subscriptionPath = () => {
  const invite = pendingInvite();
  if (invite) return `/join-school/${invite}`;
  try { return localStorage.getItem(BUSINESS_KEY) ? '/subscription#business' : '/subscription'; } catch { return '/subscription'; }
};
